import { createStore } from 'vuex';
import global from './gloabl';
import room from './room';
import home from './home';


let store: any = null;

export default () => {
  const states = {
    modules: {
      global,
      room,
      home
    }
  };
  if(import.meta.env.SSR){
    return createStore(states);
  }
  if (!store) {
    store = createStore(states);
  }
  return store;
};
  
